import { Message } from '~/components/component-library/Message'
import { BackendTransaction, TransactionStatus } from '~/types'

export const TransactionFailedMessage = ({
  transaction,
}: {
  transaction: BackendTransaction
}) => {
  if (transaction.status !== TransactionStatus.Failed) return null

  const revertReason =
    'revertReason' in transaction ? transaction.revertReason : undefined

  return (
    <Message variant="danger" title="Transaction failed">
      {revertReason ? revertReason : undefined}
    </Message>
  )
}
